'use client';

import { useRouter } from 'next/navigation';
import React from 'react';
import styles from '../styles/Home.module.css';

export default function Page() {
  const router = useRouter();
  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <div className="header">
          <h1 style={{ fontSize: '2.2rem', margin: 0 }}>毎日朝活 会議室</h1>
          <h2 style={{ fontWeight: 400 }}>5:55 開場 ・ 6:00 スタート</h2>
        </div>
        <button
          style={{ marginTop: '1.5rem', fontSize: '1.2rem', padding: '1rem 2.5rem' }}
          className="lk-button"
          onClick={() => router.push('/rooms/asakatsu')}
        >
          朝活の部屋に入る
        </button>
        <p style={{ color: '#888', marginTop: '2rem', fontSize: '0.9rem' }}>
          次の画面で名前を入れて「入室する」を押してください。
          <br />
          マイク・カメラの許可を求められたら「許可」を選んでください。
        </p>
      </main>
      <footer data-lk-theme="default">クラスNEXT 人生にサプライズを！</footer>
    </>
  );
}
